import React from 'react';

// Blog component that can navigate to posts
const Blog = ({ onNavigateToPost }) => {
  const blogPosts = [
    {
      id: 9,
      title: "The Ultimate Wedding Vow Resource Library: Examples, Templates & Guides",
      slug: "wedding-vow-resources-guide",
      excerpt: "Everything you need to write perfect wedding vows — from examples for him, her, and them to templates for nervous speakers. Our complete collection of guides and inspiration.",
      date: "2026-03-31",
      readTime: "5 min read",
      category: "Resource Guide"
    },
    {
      id: 1,
      title: "How to Write Wedding Vows: A Complete Step-by-Step Guide",
      slug: "how-to-write-wedding-vows-guide",
      excerpt: "Learn everything you need to know about writing meaningful wedding vows. From finding inspiration to delivery tips, this comprehensive guide will help you express your love perfectly.",
      date: "2026-01-10",
      readTime: "8 min read",
      category: "Writing Guide"
    },
    {
      id: 2,
      title: "What to Include in Your Wedding Vows: Essential Elements Checklist",
      slug: "what-to-include-in-wedding-vows",
      excerpt: "Not sure what to include in your vows? This checklist covers all the essential elements, from heartfelt promises to personal anecdotes that make your vows unforgettable.",
      date: "2026-01-08",
      readTime: "6 min read",
      category: "Writing Guide"
    },
    {
      id: 3,
      title: "Wedding Vow Examples: Inspiration for Every Style",
      slug: "wedding-vow-examples-inspiration",
      excerpt: "View real wedding vow examples for various styles - from traditional to modern, romantic to humorous. Find inspiration for writing your own perfect vows.",
      date: "2026-01-05",
      readTime: "10 min read",
      category: "Examples"
    },
    {
      id: 4,
      title: "Traditional vs. Modern Wedding Vows: Which Style is Right for You?",
      slug: "traditional-vs-modern-wedding-vows",
      excerpt: "Explore the differences between traditional and modern wedding vows. Learn how to choose the style that best reflects your relationship and personality.",
      date: "2026-01-02",
      readTime: "5 min read",
      category: "Style Guide"
    },
    {
      id: 5,
      title: "How Long Should Wedding Vows Be? Finding the Perfect Length",
      slug: "how-long-should-wedding-vows-be",
      excerpt: "Worried about your vows being too long or too short? This guide helps you find the perfect length for meaningful vows that won't lose your guests' attention.",
      date: "2025-12-28",
      readTime: "4 min read",
      category: "Writing Guide"
    },
    {
      id: 6,
      title: "Overcoming Writer's Block: Tips for Writing Your Wedding Vows",
      slug: "overcoming-writers-block-wedding-vows",
      excerpt: "Struggling to put your feelings into words? These practical tips will help you overcome writer's block and create heartfelt vows that truly express your love.",
      date: "2025-12-25",
      readTime: "7 min read",
      category: "Writing Tips"
    },
    {
      id: 7,
      title: "Should You Memorize Your Wedding Vows? Pros and Cons",
      slug: "memorize-wedding-vows-pros-cons",
      excerpt: "To memorize or not to memorize? Explore the advantages and disadvantages of memorizing your vows versus reading them, plus tips for either approach.",
      date: "2025-12-22",
      readTime: "5 min read",
      category: "Ceremony Tips"
    },
    {
      id: 8,
      title: "How to Add Humor to Your Wedding Vows Without Going Overboard",
      slug: "add-humor-wedding-vows",
      excerpt: "Want to make your guests laugh while still being heartfelt? Learn how to tastefully incorporate humor into your wedding vows for the perfect balance.",
      date: "2025-12-19",
      readTime: "6 min read",
      category: "Writing Tips"
    }
  ];

  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-10">
          <div className="glass-card text-center mb-5">
            <h1 className="commercial-heading mb-3">VowAuthor Blog</h1>
            <p className="commercial-subheading" style={{ fontSize: '1.1rem', color: '#000000' }}>
              Helpful guides, tips, and inspiration for writing beautiful wedding vows
            </p>
          </div>

          <div className="row g-4">
            {blogPosts.map((post) => (
              <div key={post.id} className="col-md-6">
                <div 
                  className="glass-card h-100" 
                  style={{ cursor: 'pointer' }} 
                  onClick={() => {
                    if (onNavigateToPost) {
                      onNavigateToPost(post.slug);
                    } else {
                      window.location.href = `/blog/${post.slug}`;
                    }
                  }}
                >
                  <div className="d-flex justify-content-between align-items-center mb-2">
                    <span className="badge" style={{ 
                      background: 'rgba(244, 114, 182, 0.2)', 
                      color: '#ec4899',
                      padding: '0.25rem 0.75rem',
                      borderRadius: '12px',
                      fontSize: '0.85rem'
                    }}>
                      {post.category}
                    </span>
                    <span style={{ color: '#666', fontSize: '0.85rem' }}>{post.readTime}</span>
                  </div>
                  <h3 className="mb-3" style={{ 
                    color: '#000000', 
                    fontSize: '1.5rem',
                    fontWeight: '600',
                    lineHeight: '1.3'
                  }}>
                    {post.title}
                  </h3>
                  <p style={{ 
                    color: '#000000', 
                    lineHeight: '1.7',
                    marginBottom: '1rem',
                    opacity: 0.9
                  }}>
                    {post.excerpt}
                  </p>
                  <div className="d-flex justify-content-between align-items-center">
                    <span style={{ color: '#666', fontSize: '0.9rem' }}>
                      {new Date(post.date).toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
                    </span>
                    <span style={{ color: '#ec4899', fontWeight: '600' }}>
                      Read More <i className="bi bi-arrow-right ms-1"></i>
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="text-center mt-5">
            <button 
              onClick={() => window.location.href = '/'}
              className="btn btn-primary btn-lg"
            >
              <i className="bi bi-house me-2"></i>
              Back to Home
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Blog;
